export const blockIconsSocialNotifications = (
	<span className='material-symbols-outlined'>notifications</span>
);
